import { ReactElement } from 'react';

export const Analytics = (): ReactElement | null => {
    return null; // this component will be developed in future steps
};
